import React, { useContext } from "react";
// import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import firebase from "firebase/app";

const Header = () => {
  const { user, setUser } = useContext(AuthContext);

  const handleLogout = () => {
    firebase.auth().signOut().then(() => {
      console.log("Signed out")
      setUser(null);
    }).catch((error) => {
      console.log(error);
    });
  };

  return (
    <header>
      <div className="userControls">
        {!user ? (
          <p></p>
        ) : (
          <>
          <span className="userName"><strong>{user.email}</strong></span>
          <button type="button" className="button-link" onClick={handleLogout}>Sign Out</button>
          </>
        )}
      </div>
      <h1 className="branding">merchsheet</h1>
    </header>
  )

}

export default Header;